// export const env = 'http://192.168.0.101:8000/'
// export const envU = 'http://192.168.0.101:8001/'
// export const env = 'http://localhost:8000/api/iot-station/v1.1/'
// export const envU = 'http://localhost:8001/'


export const getApiUrls = () => {
  const env = JSON.parse(sessionStorage.getItem('apiurlCr'));
  return { env };
};
export const getApiUpdateUrls = () => {
  const envU = JSON.parse(sessionStorage.getItem('apiurlu'));
  return { envU };
};
export const getLakeHouseUrls = () => {
  const envLakeH = JSON.parse(sessionStorage.getItem('lakehouseurl'));
  return { envLakeH };
};



